.modal {
    width: 670px;
}
